export default __webpack_public_path__ + "static/assets/b71afdeb3c313605616e51e75aa710b7.gif";